import React from 'react';

import { Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface MenuLinkItemProps {
  href: string;
  name: string;
  analyticsName: string;
  isActive?: boolean;
  onPress?: () => void;
  showOnTablet?: boolean;
  tabletDisplay?: string;
  isLast?: boolean;
}

export const MenuLinkItem: React.FC<MenuLinkItemProps> = ({
  href,
  name,
  analyticsName,
  isActive,
  onPress,
  isLast,
}) => {
  return (
    <Text as="li" className={cn('md:hidden', !isLast && 'border-b border-od-border-primary')}>
      <Row
        href={href}
        aria-current={isActive}
        aria-label={name}
        analyticsName={analyticsName}
        // eslint-disable-next-line react/forbid-component-props -- Atoms Row renders a native <a> when given href + aria-label
        onClick={onPress}
        className={cn('items-center py-4 pl-6 pr-4', isActive && 'bg-od-bg-hover-primary')}
      >
        <Text as="span" className="text-body-md">
          {name}
        </Text>
      </Row>
    </Text>
  );
};
